import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/FontAwesome/light/arrow-up.svg";

export function ArrowUpIcon(props: SxProps) {
    return <SvgIcon component={Icon} inheritViewBox sx={props} />;
}
